export const onboardingStyles = {
    fieldsContentOnboarding: {
        box: {
            display: "grid",
            gridTemplateColumns: {
                xs: '1fr',
                sm: '1fr',
            },
            gap: 2,
        },
        namesBox: {
            display: "grid",
            gridTemplateColumns: {
                xs: '1fr',
                sm: '1fr 1fr',
            },
            gap: 2,
            width: "100%",
        },
        dataPrivacyBox: {
            display: "grid",
            gridTemplateColumns: {
                xs: '1fr',
                sm: '3fr 1fr',
            },
            gap: 2,
            width: "100%",
        }
    },
    pageCreateOnboardingCall: {
        frame: {
            backgroundColor: 'primary.main',
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 2,
        },
        paper: {
            width: '100%',
            maxWidth: 800,
            padding: { xs: 3, sm: 4 },
            borderRadius: 4,
            color: 'text.primary',
            display: 'flex',
            flexDirection: 'column',
            gap: 3,
            boxShadow: 6,
        },
        header: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 1,
            marginBottom: 2,
        },
        appIcon: {
            width: 96,
            height: 96,
        },
    },
}